import { BasicStatistics } from '../components/stats/BasicStatistics';
import { TableContainer as ChakraTable } from '../components/table/TableContainer';

export default function Home() {
  return <>
    <BasicStatistics />
    <ChakraTable />
  </>;
}
